import styled from 'styled-components';
import { white, blue } from '../../../styles/Variables';

export const ModalWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

export const ModalContent = styled.div`
    background-color: ${white};
    padding: 2rem;
    border-radius: 5px;
    position: relative;
    text-align: center;
    max-width: 400px;
    width: 90%;
`;

export const CloseButton = styled.span`
    position: absolute;
    top: 10px;
    right: 15px;
    font-size: 28px;
    font-weight: bold;
    cursor: pointer;
    color: #aaa;

    &:hover {
        color: #000;
    }
`;

export const Title = styled.h3`
    color: ${blue};
    font-family: 'NeueHelveticaPro77CondensedBold', Helvetica, sans-serif;
    font-size: 1.5em;
    margin-bottom: 1rem;
`;

export const Description = styled.p`
    font-family: Arial, Helvetica, sans-serif;
    font-size: 1rem;
    margin-bottom: 1.5rem;
`;

export const QRCodeWrapper = styled.div`
    padding: 1rem;
    background: ${white};
    display: inline-block;
`;